import { apiCallPost } from '../api';
import { apiPaths } from '../config/apiPaths';

async function walletRequest(body, authHeaders, defaultError) {
  try {
    const res = await apiCallPost(apiPaths.wallet, body, authHeaders);
    if (res) return { status: true, data: res };
    return { status: false, errMsg: defaultError };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
}

export const getWalletBalanceApi = (_payload = {}, authHeaders = {}) =>
  walletRequest(
    { operation: 'GET_BALANCE', payload: {} },
    authHeaders,
    'Failed to load wallet balance.'
  );

export const getWalletLedgerApi = (_payload = {}, authHeaders = {}) =>
  walletRequest(
    { operation: 'GET_LEDGER', payload: {} },
    authHeaders,
    'Failed to load wallet transactions.'
  );

export const estimateWalletCostApi = (payload = {}, authHeaders = {}) =>
  walletRequest(
    { operation: 'ESTIMATE_COST', payload },
    authHeaders,
    'Failed to estimate cost.'
  );
